import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import * as moment from "moment";
import { User } from "../../@core/data/users";
import {
  NbComponentStatus,
  NbGlobalPhysicalPosition,
  NbToastrService,
} from "@nebular/theme";

@Component({
  selector: "ngx-view-time-period",
  styleUrls: ["./view-time-period.component.scss"],
  templateUrl: "./view-time-period.component.html",
})
export class ViewTimePeriodComponent implements OnInit, OnDestroy {
  private alive = true;

  @Output() periodChange = new EventEmitter<any>();
  @Input() mode?: string;
  @Input() typeSelected?: string = "today";
  @Input() allowAll?: boolean = false;
  @Input() user?: User;

  types = [
    { title: "Hôm nay", value: "today" },
    { title: "Hôm qua", value: "yesterday" },
    { title: "Tháng này", value: "thisMonth" },
    { title: "Tháng trước", value: "lastMonth" },
    { title: "Gần đây", value: "recent" }, //3 months
    // { title: "Năm này", value: "thisYear" },
    // { title: "Năm trước", value: "lastYear" },
    // { title: "Tùy chỉnh", value: "custom" },
    // { title: "Tất cả", value: "allTime" },
  ];
  type: string = "day"; //day / month
  periodDate: Date = new Date();
  fromDate: Date = new Date();
  toDate: Date = new Date();

  constructor(private toastrService: NbToastrService) {}

  ngOnInit(): void {
    if (this.mode === "dept") {
      const now = { title: "Hiện tại", value: "now" };
      this.types = [now, ...this.types];

      this.typeSelected = "now";
      // const now = { title: "Tất cả", value: "all" };
      // this.types = [now, ...this.types];

      // this.typeSelected = "all";
    }

    if (this.mode === "report") {
      this.types = [
        ...this.types,
        { title: "Năm này", value: "thisYear" },
        { title: "Năm trước", value: "lastYear" },
      ];
    }

    if (this.mode === "inventory") {
      this.types = [...this.types, { title: "Năm này", value: "thisYear" }];
    }

    if (this.allowAll) {
      this.types.push({
        title: "Tất cả",
        value: "allTime",
      });
    }

    if (this.user && !this.user.admin && !this.user.moderator) {
      this.types = [
        { title: "Hôm nay", value: "today" },
        { title: "Hôm qua", value: "yesterday" },
      ];
    }

    this.types.push({ title: "Tùy chỉnh", value: "custom" });
  }

  ngOnDestroy() {
    this.alive = false;
  }

  changePeriod(period): void {
    this.typeSelected = period;
    console.log("changePeriod:", period);

    let currentDate = new Date();

    switch (period) {
      case "today":
        this.type = "day";
        this.periodDate = moment().toDate();
        this.fromDate = moment().startOf("day").toDate();
        this.toDate = moment().endOf("day").toDate();
        break;

      case "yesterday":
        this.type = "day";
        this.periodDate = moment().add(-1, "days").toDate();
        this.fromDate = moment().add(-1, "days").startOf("day").toDate();
        this.toDate = moment().add(-1, "days").endOf("day").toDate();
        break;

      case "recent":
        this.type = "recent";
        this.periodDate = moment().toDate();
        this.fromDate = moment().add(-3, "months").startOf("month").toDate();
        this.toDate = moment().endOf("day").toDate();
        break;

      case "thisMonth":
        this.type = "month";
        this.periodDate = moment().toDate();
        this.fromDate = moment().startOf("month").toDate();
        this.toDate = moment().endOf("month").toDate();
        break;

      case "lastMonth":
        this.type = "month";
        this.periodDate = moment().add(-1, "months").toDate();
        this.fromDate = moment().add(-1, "months").startOf("month").toDate();
        this.toDate = moment().add(-1, "months").endOf("month").toDate();
        break;

      case "thisWeek":
        this.type = "week";
        this.periodDate = moment().toDate();
        this.fromDate = moment().startOf("week").toDate();
        this.toDate = moment().endOf("week").toDate();
        break;

      case "lastWeek":
        this.type = "week";
        this.periodDate = moment().add(-1, "weeks").toDate();
        this.fromDate = moment().add(-1, "weeks").startOf("week").toDate();
        this.toDate = moment().add(-1, "weeks").endOf("week").toDate();
        break;

      case "thisYear":
        this.type = "year";
        this.periodDate = moment().toDate();
        this.fromDate = moment().startOf("year").toDate();
        this.toDate = moment().endOf("year").toDate();
        break;

      case "lastYear":
        this.type = "year";
        this.periodDate = moment().add(-1, "year").toDate();
        this.fromDate = moment().add(-1, "year").startOf("year").toDate();
        this.toDate = moment().add(-1, "year").endOf("year").toDate();
        break;

      case "custom":
        this.type = "custom";
        this.periodDate = currentDate;
        break;

      case "allTime":
        this.type = "allTime";
        this.periodDate = moment().add(-1000, "years").toDate();
        this.fromDate = moment().add(-1000, "years").startOf("month").toDate();
        this.toDate = moment().add(1000, "years").endOf("month").toDate();
        break;

      case "now":
        this.type = "now";
        this.periodDate = currentDate;
        this.fromDate = moment().add(-1000, "years").startOf("month").toDate();
        this.toDate = moment().add(1000, "years").endOf("month").toDate();
        break;

      default:
        this.type = "day";
        this.periodDate = currentDate;
        this.periodDate = moment().toDate();
        this.fromDate = moment().startOf("day").toDate();
        this.toDate = moment().endOf("day").toDate();
        break;
    }

    if (this.type !== "custom") {
      this.periodChange.emit({
        periodDate: this.periodDate,
        fromDate: this.fromDate,
        toDate: this.toDate,
        type: this.type,
        period: period,
      });
    }
  }

  selectedPeriod() {
    this.periodDate = moment(this.fromDate).toDate();
    this.fromDate = moment(this.fromDate).startOf("day").toDate();
    this.toDate = moment(this.toDate).endOf("day").toDate();

    const days = moment(this.toDate).diff(moment(this.fromDate), "days");
    console.log("🚀 ~ ViewTimePeriodComponent ~ selectedPeriod ~ days:", days);

    if (days > 93 && !this.user.admin) {
      this.showToast(
        "warning",
        "Xin vui lòng chọn ngày",
        "Thời gian xem vượt quá 3 tháng",
      );
    } else {
      this.periodChange.emit({
        periodDate: this.periodDate,
        fromDate: this.fromDate,
        toDate: this.toDate,
        type: this.type,
      });
    }
  }

  private showToast(type: NbComponentStatus, title: string, body: string) {
    const config = {
      status: type,
      destroyByClick: true,
      duration: 2000,
      hasIcon: true,
      position: NbGlobalPhysicalPosition.TOP_RIGHT,
      preventDuplicates: false,
    };
    const titleContent = title ? `${title}` : "";

    this.toastrService.show(body, titleContent, config);
  }
}
